import React from 'react';

import PageTabs from 'ui/PageTabs';
import { withAppContext } from '../../AppContext';

import Access from 'ui/Access';
import Summary from './tabs/Summary';
import Counts from './tabs/Counts';
import Payment from './tabs/Payment';
import Transactions from './tabs/Transactions';
import Settings from './tabs/Settings';
import { RESELLER_LIKE } from 'utils/user';

const cantAccessTab = currentOrg => {
    return (
        currentOrg &&
        currentOrg.parent &&
        RESELLER_LIKE.indexOf(currentOrg.parent.type) >= 0 &&
        !currentOrg.parent.is_super_pb_partner
    );
};

const TAB_LIST = [
    {
        name: 'summary',
        label: 'Summary',
        component: Summary,
        access: Access.ACCOUNT_DETAILS,
    },
    {
        name: 'user_counts',
        label: 'User Counts',
        component: Counts,
        access: Access.ACCOUNT_DETAILS_USER_COUNTS,
    },
    {
        name: 'transactions',
        label: 'Transactions',
        component: Transactions,
        access: currentOrg => {
            if (cantAccessTab(currentOrg)) {
                return null;
            }
            return Access.ACCOUNT_DETAILS_TRANSACTIONS;
        },
    },
    {
        name: 'payment_method',
        label: 'Payment method',
        component: Payment,
        access: Access.ACCOUNT_DETAILS_PAYMENT_METHOD,
    },
    {
        name: 'settings',
        label: 'Settings',
        component: Settings,
        access: currentOrg => {
            if (cantAccessTab(currentOrg)) {
                return null;
            }
            return Access.ACCOUNT_DETAILS_PAYMENT_SETTINGS;
        },
    },
];

class Details extends React.Component {
    state = {
        tab: -1,
        tabs: [],
    };
    hasTab(num) {
        const { tabs } = this.state;
        return num < tabs.length;
    }
    findTab(num) {
        const { tabs } = this.state;
        return tabs[num] || tabs[0];
    }
    findTabUrl(num) {
        if (this.hasTab(num)) {
            return `/account/details/${this.findTab(num).name}`;
        }
        return '';
    }
    findTabComponent(num) {
        if (this.hasTab(num)) {
            return this.findTab(num).component;
        }
        return null;
    }
    findTabNumber(tabName) {
        const { tabs } = this.state;
        for (let i = 0; i < tabs.length; i += 1) {
            if (tabs[i].name === tabName) {
                return i;
            }
        }
        return 0;
    }
    componentDidMount() {
        this.props.updateBreadcrumbs([
            { name: 'Account', path: '/account' },
            'Details',
        ]);
        this.updateTabs();
    }
    componentDidUpdate(oldProps) {
        const tabName = this.props.tab;
        const tab = this.findTabNumber(tabName);
        if (oldProps.tab !== tabName || tab !== this.state.tab) {
            this.setState({ tab });
        }
    }
    updateTabs() {
        const accessFilter = tab => this.canViewTab(tab.access);
        const tabs = TAB_LIST.filter(accessFilter);
        this.setState({ tabs });
    }
    canViewTab(tabAccess) {
        const { app } = this.props;
        const { currentUser } = app;
        if (typeof tabAccess === 'function') {
            tabAccess = tabAccess(currentUser.organizations[0]);
        }
        return app.canView(tabAccess);
    }
    onTabChange = tab => {
        if (tab !== this.state.tab) {
            this.setState({ tab });
            if (this.hasTab(tab)) {
                this.props.history.push(this.findTabUrl(tab));
            }
        }
    };
    render() {
        const { tab, tabs } = this.state;
        if (tab === -1) {
            return null;
        }
        return (
            <PageTabs
                tabs={tabs.map(tab => tab.label)}
                current={tab}
                onChange={this.onTabChange}
            >
                {() => {
                    const Component = this.findTabComponent(tab);
                    if (Component) {
                        return <Component />;
                    }
                }}
            </PageTabs>
        );
    }
}

export default withAppContext(Details);
